<template>
  <div class="border border-blue p-2 mb-8">
    <div class="border-b border-blue pb-2 uppercase text-2xl">
      <span class="text-blue-light">{{ name }}</span>
      <span class="text-blue-lightest ml-2">{{ user }}</span>
    </div>
    <div class="uppercase text-blue-lightest text-xl py-2 border-b border-blue">VOTE: {{ vote }} - {{ voteTitle }}</div>
    <div class="mt-2">
      <span class="text-blue-light mr-2">REASONING:</span>
      <span>{{ reasoning }}</span>
    </div>
    <div class="mt-2">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentsCouncilMeetingPost',

  props: {
    name: {
      type: String,
      default: '',
    },

    user: {
      type: String,
      default: '',
    },

    vote: {
      type: String,
      default: '',
    },

    voteTitle: {
      type: String,
      default: '',
    },

    reasoning: {
      type: String,
      default: '',
    },
  },
}
</script>
